module.exports = __webpack_public_path__ + "e03523035dd96c8f8424adf2598fa0f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/retro-camera-s.png
// module id = 1367
// module chunks = 0